import AppConstants from 'constants/AppConstants';

export function closeReservationsFilter() {
  return {
    type: AppConstants.CLOSE_RESERVATIONS_FILTER,
  };
}

export function openReservationsFilter() {
  return {
    type: AppConstants.OPEN_RESERVATIONS_FILTER,
  };
}
